import { render, staticRenderFns } from "./GuestNotification.vue?vue&type=template&id=021e227f&scoped=true&"
import script from "./GuestNotification.vue?vue&type=script&lang=js&"
export * from "./GuestNotification.vue?vue&type=script&lang=js&"
import style0 from "./GuestNotification.vue?vue&type=style&index=0&id=021e227f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021e227f",
  null
  
)

export default component.exports